import React from "react";
import Reveal from "@/components/Reveal";
import { Quote } from "lucide-react";
import { SITE } from "@/lib/site";

export const FounderSection = () => (
 <section className="bg-[#F8F9FA] border-y border-[#EAEAEA]" data-testid="founder-section">
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
 <Reveal className="lg:col-span-5">
 <div className="relative">
 <div className="absolute -bottom-5 -right-5 w-32 h-32 rounded-full bg-[#FDD805] -z-0" aria-hidden />
 <div className="relative rounded-3xl overflow-hidden border border-[#EAEAEA] bg-white">
 <img
 src="/brand/bhavik.webp"
 alt={SITE.founder}
 className="w-full h-[520px] object-cover object-top"
 data-testid="founder-image"
 />
 </div>
 </div>
 </Reveal>

 <Reveal className="lg:col-span-7" delay={120}>
 <div className="text-[11px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A]">
 A note from the founder
 </div>
 <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-black tracking-tight text-[#0F1115]">
 Hi, I'm <span className="hl-yellow">Bhavik</span>.
 </h2>
 <div className="mt-6 pl-6 border-l-4 border-[#FDD805]">
 <Quote className="text-[#FDD805] mb-3" size={22} />
 <p className="text-[17px] md:text-[19px] leading-[1.6] text-[#0F1115]">
 If you are starting your business for the first time, you deserve
 more than a low-cost package. You deserve clarity, support and
 someone who helps you make the right decisions at the right stage.
 </p>
 <p className="mt-4 text-[17px] md:text-[19px] leading-[1.6] text-[#0F1115]">
 That is the philosophy behind HG Corporates. We built
 this for founders like you people trying to figure things out for
 the first time and asking honest questions that deserve honest
 answers.
 </p>
 </div>
 <div className="mt-6 text-[14px] text-[#4A4A4A]">
 <span className="font-bold text-[#0F1115]">Bhavik Hariyani</span> - 
 Founder, HG Corporates
 </div>
 </Reveal>
 </div>
 </section>
);

export default FounderSection;
